import React from "react";
import { Button, Modal } from "react-bootstrap";
import {
  DEBT_CARD_TITLE_FONT_SIZE,
  NAVY,
} from "../debt-collection-section/DebtCollectionSectionConstants";

/**
 * Confirms deletion of a franchise debt configuration.
 * @param {object} props - Modal props.
 * @param {boolean} props.show - Whether the modal is visible.
 * @param {boolean} props.submitting - Disables close/confirm while a request runs.
 * @param {function} props.onHide - Called to dismiss without deleting.
 * @param {function} props.onConfirmDelete - Called when delete is confirmed.
 * @returns {JSX.Element} Bootstrap modal.
 */
export function DebtCollectionDeleteModal({
  show,
  submitting,
  onHide,
  onConfirmDelete,
}) {
  return (
    <Modal
      show={show}
      onHide={() => !submitting && onHide()}
      centered
      container={typeof document !== "undefined" ? document.body : undefined}
    >
      <Modal.Header closeButton>
        <Modal.Title
          className="font-weight-bolder"
          style={{ color: NAVY, fontSize: DEBT_CARD_TITLE_FONT_SIZE }}
        >
          Delete configuration
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        This will remove the debt collection configuration. This action cannot
        be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirmDelete} disabled={submitting}>
          {submitting ? "Deleting…" : "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
